<template>
    <div class="ICRONPrimary">

        <!--v-toolbar app color="black" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo ml-0" src="../assets/images/Logo.png" style="height: 45px" @click="gotoHome()" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout v-if="isDesktopMode()" align-start row justify-center class="red darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"><span class="white--text"> |
                    Live
                    results
                </span>
            </v-layout>
            <v-spacer></v-spacer>
        </v-toolbar-->


        <v-layout align-start row wrap justify-center class="mb-4"  >
            <v-flex flex xs12 sm12 md12 lg12 class="white--text title ma-4 ">
                <v-layout align-start row wrap justify-center >
                    <img class="menuLogo ml-0" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 200px" />
                </v-layout>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="white--text ICRONSecondary" >
                <v-layout align-start row wrap justify-center >
                    <h1 class="white--text display-3"><strong>{{ raceInfo.name }}</strong></h1>
                </v-layout>
            </v-flex>

            
        </v-layout>

        <v-layout v-if="showResult" align-start row wrap justify-center class="pa-2 black--text  lighten-4 mt-3">
            <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                <p style="font-size: 60px;">  </p>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="white black--text pa-2 text-xs-center display-3">
                <p style="font-size: 80px;"><strong>{{ selectParticipant.participant.cognome }} {{
                    selectParticipant.participant.nome }}</strong> 
                </p>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="white black--text pa-2 text-xs-center display-3">
                <p style="font-size: 50px;">{{ selectParticipant.participant.team }} 
                </p>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                <p style="font-size: 60px;">  </p>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="pa-2 text-xs-center display-3 white black--text">
                <p style="font-size: 80px;"><strong class="ICRONPrimary pa-3 white--text">{{ selectParticipant.tempo }}</strong> 
                </p>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="pa-2 text-xs-center display-3 white black--text--text">
                <p style="font-size: 60px;">  </p>
            </v-flex>
            <v-flex flex xs3 sm3 md3 lg3 class="pa-2 text-xs-center display-3 ICRONSecondary white--text">
                <p style="font-size: 60px;">Pos. Assoluta </p>
            </v-flex>
            <v-flex flex xs3 sm3 md3 lg3 class="pa-2 text-xs-center display-3 ICRONPrimary white--text">
                <p style="font-size: 60px;"> {{ selectParticipant.posizione }} </p>
            </v-flex>
            <v-flex flex xs3 sm3 md3 lg3 class="pa-2 text-xs-center display-3 ICRONSecondary white--text">
                <p style="font-size: 60px;">Pos. Categoria </p>
            </v-flex>
            <v-flex flex xs3 sm3 md3 lg3 class="pa-2 text-xs-center display-3 ICRONPrimary white--text">
                <p style="font-size: 60px;">  {{ selectParticipant.posizioneCategoria
                }}°  {{ selectParticipant.participant.cat }}</p>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                <p style="font-size: 60px;">  </p>
            </v-flex>

        </v-layout>

        <v-layout v-else align-start row wrap justify-center class="pa-2 black--text  mt-3">

            <v-flex flex xs12 sm12 md12 lg12 class="white--text  text-xs-center mt-4 ">
                <span class="display-3 ">Inserisci il numero del tuo pettorale e premi Invio</span>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class=" pa-2">
                <p style="font-size: 60px;">  </p>
            </v-flex>

            <v-flex flex xs4 sm4 md4 lg4 class=" pa-2">
            </v-flex>

            <v-flex flex xs4 sm4 md4 lg4 class="white pa-2 text-xs-center">
                <p style="font-size: 250px; height: 400px;" class="text-xs-center"> {{ searchText }}</p>
            </v-flex>

            <v-flex flex xs4 sm4 md4 lg4 class=" pa-2">
            </v-flex>


            <v-flex v-if="messaggio != ''" flex xs12 sm12 md12 lg12 class="white--text text-xs-center ma-4 red ">
                <p style="font-size: 40px;" class=""> {{ messaggio }}</p>
            </v-flex>

        </v-layout>

    </div>
</template>


<script>


export default {
    components: {
    },
    name: 'LiveView',

    data() {
        return {

            myInterval: undefined,
            showAddTimingSourceDialog: false,
            name: '',
            sync: '00:00:00.000',

            tpSelected: undefined,

            timingPoint: undefined,

            items: [],
            itemsF: [],

            fields: [],

            filterKey: undefined,
            filterValue: undefined,
            searchText: ' ',
            direction: true,
            orderByField: null,

            coloriSplit: {},

            showColumn: 'frazioni',
            showColors: false,

            selectedResult: undefined,

            filtroSesso: 'GENERALE',

            busyChannel: false,

            cacheKey: "null",

            raceInfo: {},

            report: undefined,

            showResult: false,

            messaggio: ''

        };
    },

    created() {
        window.addEventListener('keypress', this.doCommand);
    },
    destroyed() {
        window.removeEventListener('keypress', this.doCommand);
    },



    mounted() {
        
        
        this.reportId = this.$route.params.reportId;

        console.log(this.reportId)


        clearInterval(this.myInterval);
        this.myInterval = setInterval(this.refresh, 60000, this);

        //this.listaFields = this.report.fields.sort((a, b) => a.position - b.position)

        // this.raceInfo = this.getRaceConfig('raceInfo', true)


        this.loadReport()
    },


    beforeDestroy() {
       // console.log("sono in before destroy")
        clearInterval(this.myInterval);
    },




    methods: {

        refresh: function (self) {
            self.loadReport();
        },


        loadReport(force = false) {

            const _url = "https://www.icron.it/configurazioni-gare/icronium/" + this.reportId+".json";
            this.getCall(_url).then((response) => {
                this.items = response.items;
                this.report = response.report;
                this.raceInfo = response.raceInfo

                this.itemsF = this.filteredList();

            });
        },

        doCommand(e) {
            let cmd = String.fromCharCode(e.keyCode).toLowerCase();

            const key = e.key; 
            if (key === "Backspace" || key === "Delete") {
                if (this.searchText.length > 0) this.searchText = this.searchText.splice(-1);
                return
            }

            let test =  this.searchText + cmd;
            if (isNaN(test)) return;


           // console.log(e.keyCode)
            if (e.keyCode == 13) {
                this.itemsF = this.filteredList();
               // console.log(this.itemsF)
                if (this.itemsF.length == 1) {
                    this.selectParticipant = this.itemsF[0];
                    this.showResult = true;

                    setTimeout(this.resetTime, 7000)
                } else {
                    this.messaggio = "PETTORALE " + this.searchText + " NON TROVATO O NON ANCORA ELABORATO"
                    this.searchText = ""
                    setTimeout(this.resetTime, 3000)
                }
            } else {

               // console.log(e.keyCode)

                this.searchText += cmd;
            }
        },

        resetTime() {
            this.searchText = ""
            this.showResult = false
            this.messaggio = ""
        },




        formatValue(value, split) {
            if (split.type !== undefined && split.type !== null && split.type.toUpperCase().indexOf("TEMPO") !== -1 && value != '-' && value != undefined) {
                return this.formatTimestamp(value, split.format);
            }
            if (value == undefined) return "";
            return value;
        },

        formatCell(value, split) {

            if (split.format != undefined && split.format != null && split.format != '') {
                return this.formatValue(value, split)
            }


            if (split.type == 'tempo' || split.type == 'orario') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Frazione') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Tempo Passaggio') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'Orario Passaggio') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'min') return this.formatTime(value, this.raceInfo.sport)
            else if (split.type == 'max') return this.formatTime(value, this.raceInfo.sport)
            //else if (split.type == 'Posizione Frazione') return field.posizioneFrazione
            //else if (split.type == 'Posizione Passaggio') return field.posizioneDivisione
            //else if (split.type == 'Media Frazione') return field.mediaPassaggio


            return value;
        },



        formatTime(value, sport) {
            if (value != undefined && sport == 'Running' && value.indexOf(".") != -1) {
                let valueTok = value.split(".")
                return this.riduci(valueTok[0])
            }
            return this.riduci(value);
        },

        getAlign(value) {
            if (value == "Sinistra") return "left"
            else if (value == "Destra") return "right"
            else if (value == "Centro") return "center"

            return value
        },

        closeDetail() {
            this.selectedResult = undefined;
        },

        line_classes(name) {
            if (name == 'SCONOSCIUTO') return " red darken-2  "
            let color = this.coloriSplit[name]
            if (color != undefined) return color + " lighten-3";
            return ""
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((result) => {
                    const p = result.participant
                    let res =
                        p != null &&
                        p.pettorale != null &&
                        p.pettorale == this.searchText;

                    return res;
                });
            }
            return listaSearch;
        },

    }
}
</script>
<style scoped>
td {
    height: 15px !important;
}

.ICRONPrimary {
    background-color: #1B3241;
}
.ICRONSecondary {
    background-color: #3C737B;
}
</style>
